import {Component, ComponentDefinition, ParentComponent, ValueComponentDefinition} from "components/components/Component";
import {isPostRenderedComponent} from "components/components/Component";
import $ from "jquery";
import template from "./gridLayout.hbs";

export class GridLayout implements ParentComponent {
    public componentType = "gridLayout";
    public id: string;
    public definition: GridDefinition;
    public children: Component[] = [];
    public view: Element;
    private childInsertCount = 0;

    constructor(definition: GridDefinition) {
        this.definition = definition;
    }

    public render(): Element {
        let jqueryView = $(template(this.definition));
        this.view = jqueryView[0];
        return this.view;
    }

    public appendChildView(childView: Node): void {
        $(childView).appendTo($(this.view).find(".c-input_grid-layout__item-" +
                        this.childInsertCount) as JQuery<HTMLElement>);
        this.childInsertCount++;
    }

    public postRender() {
        for (let child of this.children) {
            if (isPostRenderedComponent(child)) {
                child.postRender();
            }
        }
    }
}

export interface GridElement {
    column_start: number;
    column_end: number;
    row_start: number;
    row_end: number;
    align: AlignType;
    justify: JustifyType;
}

export interface JustifyType {
    justify: "center" | "strech" | "end" | "start";
 }

export interface AlignType {
    align: "center" | "strech" | "end" | "start";
 }

export interface GridDefinition extends ComponentDefinition, ValueComponentDefinition {
    rows: string;
    columns: string;
    areas: GridElement[];
}
